import { sassmallRequest } from "./client";

const API_ROOT = "/customer/product-activities";
const SHOP_API_ROOT = "/customer/shop-favorites";

export function pageSassmallProductFavorites(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>(`${API_ROOT}/favorites/page`, { method: "POST", body: payload });
}

export function checkSassmallProductFavorite(platform: string, itemId: string | number) {
  return sassmallRequest<boolean>(`${API_ROOT}/favorites/check`, {
    method: "GET",
    query: { platform, itemId: String(itemId) },
  });
}

export function favoriteSassmallProduct(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>(`${API_ROOT}/favorites`, { method: "PUT", body: payload });
}

export function cancelSassmallProductFavorite(platform: string, itemId: string | number) {
  return sassmallRequest(`${API_ROOT}/favorites`, {
    method: "DELETE",
    query: { platform, itemId: String(itemId) },
  });
}

export function pageSassmallProductFootprints(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>(`${API_ROOT}/footprints/page`, { method: "POST", body: payload });
}

export function removeSassmallProductFootprint(id: string | number) {
  return sassmallRequest(`${API_ROOT}/footprints/${encodeURIComponent(String(id))}`, { method: "DELETE" });
}

export function clearSassmallProductFootprints() {
  return sassmallRequest(`${API_ROOT}/footprints`, { method: "DELETE" });
}

export function getSassmallProductPreferences() {
  return sassmallRequest<{ userId?: string; likeTypes?: string[] }>(`${API_ROOT}/preferences`, { method: "GET" });
}

export function clearSassmallProductPreferences() {
  return sassmallRequest(`${API_ROOT}/preferences`, { method: "DELETE" });
}

export function recordSassmallProductFootprint(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>(`${API_ROOT}/footprints`, { method: "POST", body: payload });
}

export function pageSassmallShopFavorites(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>(`${SHOP_API_ROOT}/page`, { method: "POST", body: payload });
}

export function checkSassmallShopFavorite(platform: string, shopId: string | number) {
  return sassmallRequest<boolean>(`${SHOP_API_ROOT}/check`, {
    method: "GET",
    query: { platform, shopId: String(shopId) },
  });
}

export function favoriteSassmallShop(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>(SHOP_API_ROOT, { method: "PUT", body: payload });
}

export function cancelSassmallShopFavorite(platform: string, shopId: string | number) {
  return sassmallRequest(SHOP_API_ROOT, {
    method: "DELETE",
    query: { platform, shopId: String(shopId) },
  });
}
